/* eslint-disable complexity */
import React from 'react';
import { EListBackgroundColor, IListItemProps } from '@adac-mp/shared';
import { DiscountLabel, Typography } from '../../index';

export const ListItem = ({
	backgroundColor = 'white',
	columnRow,
	discountLabel,
	fieldName,
	fullSpace = false,
	isHighlighted,
	label,
	labelVariant = 'abstract',
	narrow,
	noBorder,
	previousValue,
	singleItem,
	subLabel,
	value,
	valueColor = 'title',
	valueVariant = 'abstract',
}: IListItemProps) => {
	return (
		<li
			className={`${
				singleItem
					? 'rounded-lg border-solid border-2 border-gray-600 mb-1.5'
					: `${
							!noBorder &&
							'last:border-b-0 border-b border-l-0 border-t-0 border-r-0 border-solid border-gray-600'
					  }`
			} flex md:gap-3 ${isHighlighted ? 'bg-gray-600/[.4]' : EListBackgroundColor[backgroundColor]} ${
				columnRow
					? 'flex-col px-3 first:pt-3.5 last:pb-3.5 py-1.5 md:flex-row'
					: `${narrow ? 'first:pt-3.5 last:pb-3.5 py-1.5' : 'py-3.5'} px-4 gap-1.5`
			} justify-between ${discountLabel && !isHighlighted ? 'items-center' : 'items-baseline'}`}>
			<div
				className={`${fieldName ? '' : 'flex flex-col justify-end'} ${
					fullSpace ? '' : `${columnRow ? 'md:basis-1/2 md:max-w-1/2' : 'basis-1/2 max-w-1/2'}`
				}`}
				style={{ wordBreak: 'break-word' }}>
				{fieldName ? (
					<>
						<Typography size="baseLg" color="title">
							{fieldName}
						</Typography>
						<span> | </span>
						<Typography className="break-words" size="baseLg" color="title" variant={labelVariant}>
							{label}
						</Typography>
					</>
				) : (
					<>
						<Typography component="p" size="baseLg" color="title" variant={labelVariant}>
							{label}
						</Typography>
						{subLabel && (
							<Typography className="inline-flex" color="lightText">
								{subLabel}
							</Typography>
						)}
					</>
				)}
			</div>
			{previousValue && discountLabel ? (
				<div
					className={`flex flex-col justify-end ${
						columnRow ? 'md:basis-1/2 md:max-w-1/2' : 'basis-1/2 max-w-1/2'
					}`}>
					<Typography className="flex-1 flex justify-end" size="baseLg" color={valueColor}>
						<>
							<Typography size="baseLg" className="line-through pr-2" color="lightText">
								{previousValue}
							</Typography>
							{value}
						</>
					</Typography>
					<DiscountLabel label={discountLabel} />
				</div>
			) : (
				<div
					className={`flex flex-col justify-end ${
						fullSpace
							? ''
							: `${columnRow ? 'md:basis-1/2 md:max-w-1/2 text-left' : 'basis-1/2 max-w-1/2 text-right'}`
					}`}>
					<Typography
						className={`inline-flex justify-end ${columnRow ? 'md:text-right' : 'text-right'}`}
						size="baseLg"
						color={valueColor}
						variant={valueVariant}>
						{value}
					</Typography>
				</div>
			)}
		</li>
	);
};
